import classNames from 'classnames';
import FJBackIcon from '../../assets/back.svg?react';
import FJCheckIcon from '../../assets/check.svg?react';
import FJScroller from '../../common/components/FJScroller/FJScroller';
import FJVideoMetaCard from '../FJVideoMetaCard/FJVideoMetaCard';
import FJLocalStore from '../../store/FJLocalStore';
import { GENERATE_STATE } from '../../constants/FJEnumConstant';
import type { FJGeneratingTaskItem } from '../../redux/action/FJGeneratingPageAction';
import type { FJGeneratingVideoMeta } from '@src/types/FJProject';
import { useGeneratingProgressLabels } from '../../hooks/useDisplayedProgressPercent';
import { useGeneratingTasks } from './useGeneratingTasks';
import styles from './FJGeneratingPage.module.less';
import FJConfig from '@src/config/FJConfig';

interface FJGeneratingPageProps {
    overallProgress: number;
    video: FJGeneratingVideoMeta;
    onBack: () => void;
}

function TaskStatusIcon({ status }: { status: FJGeneratingTaskItem['status'] }) {
    if (status === GENERATE_STATE.SUCCEEDED) {
        return (
            <span className={styles.icon_completed} aria-hidden>
                <FJCheckIcon className={styles.check_svg} />
            </span>
        );
    }
    if (status === 'loading') {
        return <span className={styles.icon_loading} aria-hidden />;
    }
    return <span className={styles.icon_pending} aria-hidden />;
}

export default function FJGeneratingPage({ overallProgress, video, onBack }: FJGeneratingPageProps) {
    const tasks = useGeneratingTasks(overallProgress);
    const { generatingPercentLabel: progressHeading, generatingPageHintKey: hintKey } =
        useGeneratingProgressLabels(overallProgress);
    const backDisabled = overallProgress >= 75;

    return (
        <FJScroller className={styles.root}>
            {/* <button type='button' className={styles.back_btn} onClick={onBack} disabled={backDisabled}>
                <FJBackIcon className={styles.back_icon} aria-hidden />
                <span>{FJLocalStore._('back-to-home')}</span>
            </button> */}
            <div className={styles.main}>
                <div className={styles.left}>
                    <FJVideoMetaCard
                        thumbnailUrl={video.thumbnailUrl}
                        title={video.title}
                        sourceUrl={video.sourceUrl}
                        resolutionLabel={video.resolutionLabel}
                    />

                    <h1 className={styles.progress_title}>{progressHeading}</h1>
                    <p className={styles.hint}>{FJLocalStore._(hintKey)}</p>

                    <ul className={styles.task_list}>
                        {tasks.map(task => (
                            <li key={task.id} className={classNames(styles.task_row, styles[`task_${task.status}`])}>
                                <TaskStatusIcon status={task.status} />
                                <span className={styles.task_label}>{FJLocalStore._(task.labelKey)}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={styles.right}>
                    <div className={styles.illustration}>
                        <video
                            src={FJConfig.VIDEO_PATH + 'long-to-shorts.mp4'}
                            className={styles.illustration_img}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                    </div>
                </div>
            </div>
        </FJScroller>
    );
}
